<div class="background">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="login-wrapper">
                <div class="login-title">
                    <h4 class="card-title">
                        <cqes-icon></cqes-icon>
                        <img src="../../../../../../assets/images/svg-icons/svg-new/fingerprint.svg" />
                        <span>{{'auth.chooseLoginAccount' | translate}}</span>
                    </h4>
                </div>
                <div class="select-profile">
                    <mat-form-field>
                        <mat-select name="login-account"
                            [(value)]="selected">
                            <mat-option value="personal">
                                {{'auth.accounts.personal' | translate}}
                            </mat-option>
                            <mat-option *ngFor="let a of accounts"
                                [value]="a.cmrId">
                                {{getName(a)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="continue-button">
                        <button (click)="continueLogin()" class="mat-mdc-raised-button">
                            {{'auth.continue' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>